module.exports = __webpack_public_path__ + "static/media/ophos-tech.2e2b545f.svg";